import type { ComponentProps } from "react";

import { checkoutStore } from "../Checkout.store";
import type { DeliveryAgent } from "./Delivery.utils";

export default function DeliveryAgents({
  agents,
  ...props
}: {
  agents?: DeliveryAgent[];
} & ComponentProps<"select">) {
  const deliveryOption = checkoutStore((state) => state.deliveryOption);
  if (!agents?.length) return null;
  return (
    <select
      className="w-full border bg-white p-2"
      disabled={agents.length === 1}
      value={deliveryOption?.agent}
      {...props}
    >
      {agents.map((agent) => (
        <option key={agent?.id} value={agent?.id}>
          {agent?.name}, {agent.address}, {agent.city}
        </option>
      ))}
    </select>
  );
}
